import React from "react";

import { BrokerProperties } from "../BrokerProperties";

const RealEstateAgent = ({ base_route = "broker", isREAgent = false }) => {
  return (
    <div className="broker-create-account admin_wrapper">
      <BrokerProperties base_route={base_route} isREAgent={isREAgent} />
    </div>
  );
};

export default RealEstateAgent;
